import h from 'hyperscript';
import closeIcon from '@disy/cadenza-icons/close.svg';

import { Dialog } from 'ui/dialog/dialog';

import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { commonI18n as i18n } from 'cadenza/utils/i18n/i18n';
import { icon } from 'cadenza/utils/icon/icon';
import { logger } from 'cadenza/utils/logging';
import { px } from 'cadenza/utils/px';

import './drill-through-url-dialog.css';

const COMPONENT_NAME = 'd-drill-through-url-dialog';

class DrillThroughUrlDialog extends Dialog {

  #iframeElement;
  #titleElement;

  constructor (url, options) {
    super();
    const urlToOpen = cadenzaUrl(url);
    this.dialog.append(this._createHeader(urlToOpen));
    this.dialog.append(this._createIFrameContainer(urlToOpen));
    _applyOptions(this.dialog, options);
  }

  connectedCallback () {
    super.connectedCallback();
    this.dialog.classList.add(COMPONENT_NAME);
  }

  _createHeader (src) {
    this.#titleElement = h(`span.d-info-dialog--title.${COMPONENT_NAME}--title`, h('span', src));
    return h('header.d-compact-header', [
      this.#titleElement,
      h('button.button.button-icon.button-borderless.close', {
        'type': 'button',
        'title': i18n('close'),
        'onclick': () => this.dialog.close()
      }, icon(closeIcon))
    ]);
  }

  _createIFrameContainer (src) {
    this.#iframeElement = h('iframe',
      {
        src,
        frameBorder: '0',
        style: { height: '100%', width: '100%' },
        onload: () => this._updateTitle()
      },
      h('p', i18n('dialog.noEmbeddedFrames')));
    return h('div.d-drill-through-url-dialog--iframeContainer', this.#iframeElement);
  }

  _updateTitle () {
    const contentDocument = this.#iframeElement.contentDocument;
    if (contentDocument) {
      const iFrameTitle = contentDocument.title;
      const iFrameLocation = contentDocument.location;
      const newTitle = iFrameTitle || iFrameLocation;
      if (newTitle) {
        this.#titleElement.innerHTML = '';
        this.#titleElement.append(h('span', newTitle));
      }
    }
  }

}

function _applyOptions (dialog, options) {
  const dialogOptions = {};
  if (options) {
    options.split(',').forEach(optionAssignment => {
      const optionKvp = optionAssignment.split('=').map(entry => entry.trim());
      dialogOptions[optionKvp[0]] = optionKvp[1];
    });
  }
  const height = _getSizeProperty('height', dialogOptions);
  if (height) {
    dialog.style.height = height;
  }
  const width = _getSizeProperty('width', dialogOptions);
  if (width) {
    dialog.style.width = width;
  }
  const left = _getSizeProperty('left', dialogOptions);
  if (left) {
    dialog.style.marginLeft = left;
  }
  const top = _getSizeProperty('top', dialogOptions);
  if (top) {
    dialog.style.top = top;
  }
}

function _getSizeProperty (propertyName, dialogOptions) {
  if (dialogOptions[propertyName] && !Number.isNaN(parseInt(dialogOptions[propertyName]))) {
    return px(parseInt(dialogOptions[propertyName]));
  }
  return null;
}

export function openDrillThroughUrlDialog (url, options) {
  const drillThroughUrlDialog = new DrillThroughUrlDialog(url, options);
  drillThroughUrlDialog.onclose = () => {
    drillThroughUrlDialog.remove();
  };
  document.body.appendChild(drillThroughUrlDialog);
  drillThroughUrlDialog
    .showModal()
    .catch(err => logger.error('Error while trying to open a DrillTroughUrlDialog with url [' + url + '].', err));
}

customElements.define(COMPONENT_NAME, DrillThroughUrlDialog);
